import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { text: String }

  copy = async (event) => {
    event?.preventDefault()

    const button = event?.currentTarget ?? this.element

    try {
      await navigator.clipboard.writeText(this.textValue)

      const original = button.innerHTML
      button.classList.add('copy-controller-copied')
      button.innerHTML = 'Copied!'

      setTimeout(() => {
        button.classList.remove('copy-controller-copied')
        button.innerHTML = original
      }, 1200)
    }
    catch (err) {
      console.error('Failed to copy:', err)
    }
  }
}
